import { Play, Lock } from 'lucide-react'

interface LessonItemProps {
  lessonNumber: number
  title: string
  duration: string
  isActive: boolean
  isLocked: boolean
}

export function LessonItem({ lessonNumber, title, duration, isActive, isLocked }: LessonItemProps) {
  return (
    <div
      className={`flex cursor-pointer items-start gap-4 rounded-lg p-4 transition-all ${
        isActive
          ? "bg-teal-50 ring-2 ring-teal-500"
          : "opacity-60 hover:opacity-100"
      }`}
    >
      <div
        className={`flex size-8 flex-shrink-0 items-center justify-center rounded-full ${
          isActive ? "bg-teal-500 text-white" : "bg-gray-300 text-gray-600"
        }`}
      >
        {isLocked ? (
          <Lock className="w-4 h-4" />
        ) : (
          <Play className="w-4 h-4" />
        )}
      </div>
      <div className="flex flex-col">
        <p className={`font-bold text-sm ${isActive ? "text-teal-600" : "text-gray-600"}`}>
          Lesson {lessonNumber}: {title}
        </p>
        <p className="text-xs text-gray-500">
          {isActive ? "Currently watching • " : ""}{duration}
        </p>
      </div>
    </div>
  )
}
